<template>
  <CCardBody class="py-4 my-2">
    <a href="#" @click.prevent="openForm = !openForm" class="font-weight-bold text-gray-base text-decoration">
      {{ $t(`manageplan.component.card.promoCode.text`) }}
    </a>
    <transition-group name="fade">
      <div class="d-flex mt-3 justify-content-between content-center" v-if="openForm" :key="11">
        <form class="d-flex mt-3 justify-content-between">
          <CInput type="text" class="newInput mb-0 mr-3" />
          <CButton class="font-base btn btn-outline-primary px-5"> Apply </CButton>
        </form>
        <span @click="openForm = !openForm" class="font-xl"> X </span>
      </div>

      <div :key="12" v-if="hasCode">
        <div class="d-flex justify-content-between">
          <span class="mb-4 font-weight-bold"> {{ $t(`manageplan.component.card.promoCode.labelCode`) }} {{ promoCode }} </span>
          <span>
            <a href="#" @click.prevent="" class="text-decoration"> {{ $t(`manageplan.component.card.promoCode.remove`) }}</a>
          </span>
        </div>

        <div v-html="$t(`manageplan.component.card.promoCode.textPromoCodeResponse`, [1020])"></div>
      </div>
    </transition-group>
  </CCardBody>
</template>

<script>
export default {
  name: 'CardCodePromo',
  data() {
    return {
      openForm: false,
      hasCode: true,
      promoCode: 'SENDITOFF10',
      amountDiscount: 0,
    }
  },
}
</script>

<style lang="scss"></style>
